module.exports = __webpack_public_path__ + "img/V-R-135-unload-standup-top.c67545b7.png";